import React from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import { useFormContext } from "react-hook-form";
import ErrorMessage from "./common/ErrorMessage";
import { getError } from "../../utils/validations";
import { TextField } from "@material-ui/core/";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: theme.spacing(2),
    minWidth: "100%",
  },
}));

const TextInput = withStyles((theme) => ({
  root: {
    '& input:not(:last-child)': {
      height: "0.5rem"
    },
    '& label.MuiFormLabel-root': {
      borderRadius: "5px",
      paddingBottom: theme.spacing(2),
      color: theme.palette.border.main,
    },
    '& label.MuiInputLabel-shrink:not(.Mui-focused)': {
      top: '0',
    },
    '& label:not(.Mui-focused)': {
      top: '-0.3rem',
      color: theme.palette.text.placeholder,
      fontWeight: theme.typography.fontWeightMedium,
    },
    '& label.Mui-focused': {
      color: theme.palette.background.drawer,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: theme.palette.background.drawer,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.border.main,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.background.drawer,
        border: "2px solid " + theme.palette.background.drawer,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.background.drawer,
      },
    },
  },
}))(TextField);

const InputField = ({ name, label, multiline, rows, validations }) => {
  const classes = useStyles();
  const { register } = useFormContext();

  return (
    <FormControl className={classes.formControl}>
      <TextInput
        inputRef={register(getError({ validations }))}
        name={name}
        variant="outlined"
        label={label}
        multiline={multiline}
        rows={rows}
      />

      <ErrorMessage name={name} />
    </FormControl>
  );
};

TextField.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  validations: PropTypes.object,
};

export default InputField;
